import logo from './images/logo.png';
import logosmall from './images/dailogix_small.png'

export const appname = 'Dialogix';
export const applogo = logo;
export const appnameonly = logosmall;

export const slides = [
    { title: "Scale your Business", desc: "The most powerful WhatsApp API platform for modern developers.", accent: "#55e7f7" },
    { title: "Automate Growth", desc: "Set up smart chatbots that work for you while you sleep.", accent: "#fbbf24" },
    { title: "Global Reach", desc: "Connect with customers in 190+ countries instantly.", accent: "#34d399" }
  ];
